import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoDespesasPorOrgao: ['administracao'],
    removeOrgaoDespesasPorOrgao: ['orgao'],
    removeFuncaoDespesasPorOrgao: ['funcao'],
    removeSubFuncaoDespesasPorOrgao: ['subFuncao'],
    removeDespesaDespesasPorOrgao: ['despesa'],
    removeRecursoVinculadoDespesasPorOrgao: ['recursoVinculado'],
    removeRecursoDestinacaoDespesasPorOrgao: ['recursoDestinacao'],
    setMostraAplicarFiltroDespesasPorOrgao: [],
    limpaFiltroDespesasPorOrgao: [],
    aplicarFiltroDespesasPorOrgao: ['filtro'],
})

const INITIAL_STATE = {
    administracoes: [],
    orgaos: [],
    funcoes: [],
    subFuncoes: [],
    despesa: [],
    recursosVinculados: [],
    recursosDestinacao: [],
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracoes.splice(state.administracoes.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracoes = Array.from(state.administracoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeOrgao = (state = INITIAL_STATE, action) => {
    state.orgaos.splice(state.orgaos.indexOf(action.orgao))

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.orgaos = Array.from(state.orgaos)
    return { ...state, mostraAplicarFiltro: true }
}

const removeFuncao = (state = INITIAL_STATE, action) => {
    state.funcoes.splice(state.funcoes.indexOf(action.funcao))

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.funcoes = Array.from(state.funcoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeSubFuncao = (state = INITIAL_STATE, action) => {
    state.subFuncoes.splice(state.subFuncoes.indexOf(action.funcao))

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.subFuncoes = Array.from(state.subFuncoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeDespesa = (state = INITIAL_STATE, action) => {
    state.despesas.splice(state.despesas.indexOf(action.despesa))

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.despesas = Array.from(state.despesas)
    return { ...state, mostraAplicarFiltro: true }
}

const removeRecursoVinculado = (state = INITIAL_STATE, action) => {
    state.recursosVinculados.splice(state.recursosVinculados.indexOf(action.recursoVinculado), 1)
    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.recursosVinculados = Array.from(state.recursosVinculados)
    return { ...state, mostraAplicarFiltro: true }
}

const removeRecursoDestinacao = (state = INITIAL_STATE, action) => {
    state.recursosDestinacao.splice(state.recursosDestinacao.indexOf(action.recursoDestinacao), 1)
    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.recursosDestinacao = Array.from(state.recursosDestinacao)

    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_DESPESAS_POR_ORGAO]: removeAdministracao,
    [Types.REMOVE_ORGAO_DESPESAS_POR_ORGAO]: removeOrgao,
    [Types.REMOVE_FUNCAO_DESPESAS_POR_ORGAO]: removeFuncao,
    [Types.REMOVE_SUB_FUNCAO_DESPESAS_POR_ORGAO]: removeSubFuncao,
    [Types.REMOVE_DESPESA_DESPESAS_POR_ORGAO]: removeDespesa,
    [Types.REMOVE_RECURSO_VINCULADO_DESPESAS_POR_ORGAO]: removeRecursoVinculado,
    [Types.REMOVE_RECURSO_DESTINACAO_DESPESAS_POR_ORGAO]: removeRecursoDestinacao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_DESPESAS_POR_ORGAO]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_DESPESAS_POR_ORGAO]: limpaFiltro,
    [Types.APLICAR_FILTRO_DESPESAS_POR_ORGAO]: aplicarFiltro,
})
